import {useCallback, useEffect} from "react";
import {batch, useComputed, useSignal} from "@preact/signals-react";

import {BACKEND_APIS, DATE_METRICS, GROUPED_BY} from "@constants";
import {isBannersPercentageReachLoading} from "../@signals";
import useBannerPercentageSearch from "./useSearch";


export default function useBannerPercentageReach() {
    const totalKey = useSignal(DATE_METRICS.DAILY)
    const shareKey = useSignal(GROUPED_BY.BRAND)
    const forceLoad = useSignal(false)
    const data = useSignal([])

    const isClickedRemaining = ![GROUPED_BY.BRAND, GROUPED_BY.COMPANY].includes(shareKey.value)
    const { isLoading, currentData, totalTitle, shareTitle, handleDownload } = useBannerPercentageSearch(
        `${BACKEND_APIS.BANNERS}/percentage/wrapped/dynamic`,
        forceLoad.value,
        { splitKpi: [totalKey.value, shareKey.value] },
        false
    )

    useEffect(() => {
        forceLoad.value = true
    }, [shareKey.value, totalKey.value])

    useEffect(() => {
        if (isLoading) {
            data.value = []
            isBannersPercentageReachLoading.value = true
        } else {
            if (forceLoad.value)
                forceLoad.value = false
            data.value = currentData.map(item => ({
                ...item,
                rows: item.rows.map(row => {
                    if (!!row?.remainingData?.length) {
                        const labelsID = row.remainingData.map(rd => rd.labelID)
                        if (isClickedRemaining) {
                            if (shareKey.value === GROUPED_BY.PAGE_PRODUCT_TYPE)
                                row.pageProductTypeID = [...labelsID]
                            else if (shareKey.value === GROUPED_BY.PAGE_CATEGORY)
                                row.pageCategoryID = [...labelsID]
                            else if (shareKey.value === GROUPED_BY.IMAGE_TYPE)
                                row.imageTypeID = [...labelsID]
                        }
                    }
                    return row
                })
            }))
            isBannersPercentageReachLoading.value = false
        }
    }, [isLoading])

    const handleChangeTotalKey = useCallback(newValue => {
        totalKey.value = newValue
    }, [])

    const handleChangeShareKey = useCallback(newValue => {
        shareKey.value = newValue
    }, [])

    return {
        isLoading,
        data: data.value,
        totalKey: totalKey.value,
        shareKey: shareKey.value,
        isClickedRemaining,
        totalTitle,
        shareTitle,

        handleChangeTotalKey,
        handleChangeShareKey,
        handleDownload
    }
}
